import { render, staticRenderFns } from "./adminRegion.vue?vue&type=template&id=af90c2ac&scoped=true&"
import script from "./adminRegion.vue?vue&type=script&lang=js&"
export * from "./adminRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af90c2ac",
  null
  
)

component.options.__file = "adminRegion.vue"
export default component.exports